import { render, staticRenderFns } from "./InstitutionUpdateForm.vue?vue&type=template&id=d3ca5fca&"
import script from "./InstitutionUpdateForm.vue?vue&type=script&lang=js&"
export * from "./InstitutionUpdateForm.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionUpdateForm.vue?vue&type=style&index=0&id=d3ca5fca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports